import * as React from "react";
const SvgCheckboxBlue = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 2, y: 2, width: 20, height: 20, rx: 3, stroke: "#0062CC", strokeWidth: 2 }));
export default SvgCheckboxBlue;
